import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  devices: {}
});

export function setDevice(state, data) {
  const { shortId } = data.payload;
  return state.setIn(['devices', shortId], {
    shortId,
    stamp: new Date().getTime()
  });
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'HEARTBEAT':
      return setDevice(state, action.data);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/heartbeat.js